import React, { useState, useRef, useEffect } from 'react'
import {
  RadioWrapper,
  RadioInput,
  RadioLabel,
  RadioImage,
  RadioText,
} from './styles'
const RadioItem = ({ item, index }) => {
  const inputCheck = useRef()
  const { imgSrc, text, onChangeFunc, isRadioChecked, isDisplay } = item
  const [isChecked, setIsChecked] = useState(isRadioChecked)
  const [isShowUp, setIsShowUp] = useState(isDisplay)
  //useEffect to update the check status according element checked status
  useEffect(() => {
    setIsChecked(isRadioChecked)
    setIsShowUp(isDisplay)
  }, [isRadioChecked, isDisplay])
  return (
    <RadioWrapper
      key={`${text}-${index}`}
      name="Radio button"
      isDisplay={isShowUp}
    >
      <RadioInput
        type="radio"
        name="radio"
        ref={inputCheck}
        id={`${text}-${index}`}
        checked={isChecked}
        aria-checked={isChecked ? true : false}
        onChange={onChangeFunc(text)}
      />
      <RadioLabel htmlFor={`${text}-${index}`}>
        {imgSrc && <RadioImage src={imgSrc} alt={`${text} logo`} />}
        <RadioText>{text}</RadioText>
      </RadioLabel>
    </RadioWrapper>
  )
}

export default RadioItem
